import { Component, OnInit } from '@angular/core';
import { environment } from './../environments/environment';
import { LearnerService } from './core/services/learner.service';
import { PermissionService } from './core/services/permission-service.service';
import { LoginService } from './core/login/login.service';
import { Router } from '@angular/router';

@Component({
  selector: "app-root",
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  get showGiaFab(): boolean {
    const path = this.router.url.split('?')[0].split('#')[0];
    return path === '/home';
  }

  constructor(
    private learnerService: LearnerService,
    private permissionService: PermissionService,
    private loginService: LoginService,
    public router: Router
  ) {
    console.log(environment.production);
    this.disableConsole();
  }

  ngOnInit(): void {
    const token = localStorage.getItem('accessToken');
    if (token) {
      this.learnerService.getEmployeeDetails().subscribe({
        next: (res: any) => {
          this.permissionService.setPermissions(res.employee_permissions);
          this.permissionService.setEmployeeData(res.data);
          console.log('Permissions set in permission service');
        },
        error: () => {
          console.error('Failed to  set  permissions in permission service');
          console.error('failed to get emp details redirecting to login page ');
          this.permissionService.setPermissions(null);
          this.permissionService.setEmployeeData(null);
          this.loginService.logout();
        }
      });

      // Fetch festival theme globally and log response
      this.learnerService.fetchFestivalTheme().subscribe({
        next: (res) => {
          console.log('Festival Theme API response:', res);
        },
        error: (err) => {
          console.error('Festival Theme API error:', err);
        }
      });
    }

  }

  disableConsole() {
    if (environment.production) {
      window.console.log = function () { }; // disable any console.log debugging statements in production mode
      // window.console.error = function () { };
    }
  }
  title = 'learning-portal';

}
